import { Flex, Icon, IconButton, Text, VStack } from '@chakra-ui/react';
import { IPlanAdd } from '@shared/components';
import { convertNumberToLocaleString } from '@shared/utils';
import { X } from 'lucide-react';
import { useTranslation } from 'react-i18next';

interface IProductItemProps {
  product: IPlanAdd;
  onDelete?: (planId: string) => void;
}

export const ProductItem = ({ product, onDelete }: IProductItemProps) => {
  const { t } = useTranslation('checkout/common');
  const total = product.amountPrice * product.quantity;

  const typeDivision = {
    DAILY: 365,
    WEEKLY: 52,
    MONTHLY: 12,
    YEARLY: 1,
  };
  return (
    <Flex justify="space-between" align="center" gap={2}>
      <VStack spacing={0} align="start">
        <Text fontSize="sm" color="brand.500" fontWeight="semibold">
          {product.title}{' '}
          {product.duration / typeDivision[product.type] + ' ' + t('years')}
        </Text>
        <Text fontSize="sm" color="neutral.800" fontWeight="medium">
          {product.quantity} X R${' '}
          {convertNumberToLocaleString(product.amountPrice)} / {t('month')}
        </Text>
      </VStack>
      <Flex flexWrap="nowrap">
        <Text
          fontSize="lg"
          color="brand.500"
          fontWeight="semibold"
          whiteSpace="nowrap"
        >
          {convertNumberToLocaleString(total)}
        </Text>

        {!!onDelete && (
          <IconButton
            aria-label="delete"
            variant="outline"
            borderRadius="full"
            ml={2}
            size="xs"
            onClick={() => onDelete(product.id)}
            icon={<Icon as={X} color="red.500" />}
          />
        )}
      </Flex>
    </Flex>
  );
};
